.root {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: start;
  gap: 11px;
  width: 100%;
  padding: 12px 13px;
  border: 0;
  border-left: 2px solid transparent;
  background: transparent;
  color: var(--ink);
  text-align: left;
  transition:
    background-color 120ms ease,
    border-color 120ms ease;
}

.root:hover,
.root[data-active='true'] {
  background: var(--sunk);
}

.root[data-active='true'] {
  border-left-color: var(--accent);
}

.avatarWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
}

.main {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.head {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 8px;
}

.name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: 600 13px/1.25 var(--font-ui);
}

.channel {
  flex: 0 0 auto;
  color: var(--ink-3);
  font: 600 9px/1 var(--font-mono);
  letter-spacing: 0.08em;
}

.preview {
  overflow: hidden;
  color: var(--ink-3);
  text-overflow: ellipsis;
  white-space: nowrap;
  font: 11.5px/1.35 var(--font-ui);
}

.meta {
  display: flex;
  min-width: 24px;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.time {
  color: var(--ink-4);
  font: 10px/1 var(--font-mono);
}

/* Кто написал последним. Приглушённее самой реплики: это подпись к ней, а не часть текста. */
.previewFrom {
  color: var(--ink-4);
}

/* Диалог ведёт помощник. Точкой и мелким текстом — признак строки, а не её содержание. */
.mode {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--ink-4);
  font: 10.5px/1.35 var(--font-ui);
}

.mode::before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: var(--violet);
}

/*
 * «Ждёт ответа» — ЧИСЛО, а не точка (7.1, и так же в макете): величина счётная, по ней разбирают
 * очередь, и «две реплики без ответа» это не то же самое, что «одна». Точка отвечала бы только
 * «что-то есть».
 */
.unanswered {
  display: grid;
  min-width: 17px;
  height: 17px;
  padding: 0 5px;
  place-items: center;
  border-radius: 999px;
  background: var(--accent);
  color: var(--on-accent);
  font: 700 10px/1 var(--font-ui);
}

/* `top`/`left` — страж: абсолютная подпись без них встаёт по своей СТАТИЧЕСКОЙ позиции, и там, где
   позиционированного предка нет, растягивает ДОКУМЕНТ собой
   (замер и разбор — `features/content-editor/ui/ContentEditor.module.css`). */
.srOnly {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
